export default "__VITE_ASSET__6eddf06b__"